import * as React from "react";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Row, Button, Switch, Tabs } from "antd";
import { notificationError, notificationSuccess } from "utils/libHelpers/AntdNotification";
import { Loader } from "Components/General/Loader";
import { customerTextBlockStore } from "./CustomerTextBlockStore";
import { withRouter, WithRouterProps } from "Components/General/WithRouter";
import { RichEditor, RichEditorInstance } from "Pages/Project/Overview/Components/RichEditor/RichEditor";

interface CustomerInfoProps extends WithTranslation, WithRouterProps {}

export const CustomerInfo = withTranslation([I18N_NS.PROJECT, I18N_NS.GENERAL])(
  withRouter(
    observer(
      class extends React.Component<CustomerInfoProps> {
        editorDE = React.createRef<RichEditorInstance>();
        editorEN = React.createRef<RichEditorInstance>();

        state = {
          activeKey: "German dashboard info text",
        };

        componentDidMount() {
          const { de, en } = customerTextBlockStore.html;
          if (!de || !en) {
            (async () => await customerTextBlockStore.fetch())();
          }
        }

        handleEdit = async () => {
          const { t } = this.props;
          try {
            await customerTextBlockStore.edit({
              de: this.editorDE.current?.getHtml(),
              en: this.editorEN.current?.getHtml(),
            });
            notificationSuccess(t(`${I18N_NS.GENERAL}:::Success`), t(`${I18N_NS.GENERAL}:::Info saved`));
          } catch (error) {
            notificationError(t(`${I18N_NS.GENERAL}:::Error`), t(`${I18N_NS.GENERAL}:::Sorry something went wrong.`));
          }
        };

        handleSwitch = (checked: boolean) => {
          customerTextBlockStore.switch(checked);
        };

        get pages() {
          return [
            {
              label: "German dashboard info text",
              language: "DE",
              component: (
                <RichEditor initialValue={customerTextBlockStore.getCustomerInfoByLang("de")} ref={this.editorDE} />
              ),
            },
            {
              label: "English dashboard info text",
              language: "EN",
              component: (
                <RichEditor initialValue={customerTextBlockStore.getCustomerInfoByLang("en")} ref={this.editorEN} />
              ),
            },
          ];
        }

        public render() {
          const { t } = this.props;

          if (customerTextBlockStore.state !== "DONE") {
            return <Loader />;
          }

          return (
            <div className="g-card">
              <Tabs
                activeKey={this.state.activeKey}
                onChange={(activeKey) => this.setState({ activeKey })}
                tabBarExtraContent={
                  <div>
                    {t("Activate")}
                    <Switch
                      checked={customerTextBlockStore.active}
                      onChange={this.handleSwitch}
                      style={{ marginLeft: `10px` }}
                    />
                  </div>
                }
                items={this.pages.map((page) => ({
                  key: page.label,
                  label: t(`${I18N_NS.GENERAL}:::${page.label}`),
                  children: page.component,
                }))}
              />
              <Row justify="space-between" style={{ marginTop: "20px" }}>
                <Button onClick={() => this.props.navigate("/admin")}>{t(`${I18N_NS.GENERAL}:::Cancel`)}</Button>
                <Button type="primary" onClick={this.handleEdit}>
                  {t("Save")}
                </Button>
              </Row>
            </div>
          );
        }
      }
    )
  )
);
